import React from 'react';

import classnames from 'clsx';
import { get } from 'lodash-es';
import PropTypes from 'prop-types';

import { ButtonThemeService } from 'ui-components/services/button-theme-service';

import { MultiactionLabelButton } from '../multiaction-label-button';

import style from './shipment-configuration-widget.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

export const PrimaryActionButton = ({
  primaryActions = emptyArray,
  defaultPrimaryActionId = '',
  theme = 'primary',
  disabled = false,
  buttonClassName,
  buttonContainerClassName,
  buttonLabelClassName,
  disabledTooltipMessage,
  isLightTheme = false,
}) => (
  <span
    className={classnames({
      [[style['primary-single-action']]]: get(primaryActions, 'length', 0) <= 1,
    })}
  >
    <MultiactionLabelButton
      buttonClassName={buttonClassName}
      buttonContainerClassName={buttonContainerClassName}
      buttonLabelClassName={buttonLabelClassName}
      defaultPrimaryActionId={defaultPrimaryActionId}
      disabled={disabled}
      disabledTooltipMessage={disabledTooltipMessage}
      isLightTheme={isLightTheme}
      primaryActions={primaryActions}
      theme={theme}
    />
  </span>
);

PrimaryActionButton.propTypes = {
  primaryActions: PropTypes.array,
  defaultPrimaryActionId: PropTypes.string,
  theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  disabled: PropTypes.bool,
  buttonClassName: PropTypes.string,
  buttonContainerClassName: PropTypes.string,
  buttonLabelClassName: PropTypes.string,
  disabledTooltpMessage: PropTypes.string,
  isLightTheme: PropTypes.bool,
};
